import { render, staticRenderFns } from "./vProductos.vue?vue&type=template&id=06366f04"
import script from "./vProductos.vue?vue&type=script&lang=js"
export * from "./vProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports